import { motion } from "framer-motion";
import { FadeUp } from "../../components/AnimationWrapper";

export const ServicesHero = () => {
  return (
    <section className="relative h-[80vh] flex items-center justify-center text-center overflow-hidden">

      {/* 🔥 Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1555066931-4365d14bab8c')",
        }}
      />

      {/* 🔥 Overlay */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      {/* 🔥 Content */}
      <div className="relative z-10 max-w-3xl px-6 text-white">

        <FadeUp>
          <p className="mb-4 text-sm bg-white/10 inline-block px-4 py-1 rounded-full">
            🚀 Our Services
          </p>
        </FadeUp>

        <FadeUp delay={0.2}>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight mb-6">
            We Build Powerful <br />
            <span className="text-blue-400">
              Digital Solutions
            </span>
          </h1>
        </FadeUp>

        <FadeUp delay={0.4}>
          <p className="text-gray-200 mb-8">
            From web apps to AI-powered systems, we deliver scalable,
            modern, and high-performance solutions for startups and businesses.
          </p>
        </FadeUp>

        <FadeUp delay={0.6}>
          <div className="flex justify-center gap-4 flex-wrap">

            <motion.button
              whileHover={{ scale: 1.05 }}
              className="px-6 py-3 bg-blue-500 rounded-lg font-semibold shadow"
            >
              Get Started
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.05 }}
              className="px-6 py-3 border border-white rounded-lg"
            >
              Contact Us
            </motion.button>

          </div>
        </FadeUp>

      </div>
    </section>
  );
};